// Widget CSS
import '@/css/_elementor/widgets/card_testimonial.css';

// ..........................................................................................

import { ShuffleColors } from '@/js/utilities/color-shuffle';

// ..........................................................................................

window.addEventListener('elementor/frontend/init', () => {
	elementorFrontend.hooks.addAction('frontend/element_ready/card_testimonial.default', (scope) => {
		const scopeEl = scope[0];
		// ...

		const containerEl = scopeEl.querySelector('.card_testimonial');

		if (!containerEl) return;

		new ShuffleColors({
			container: containerEl,
			items: '.card',
			colors: ['#C9D0FC', '#61A2F8', '#EB6942', '#F9D757', '#B0EAC3'],
		});

		//
	});
});
